import Relay from 'react-relay/classic';

export default class ResendEmailVerificationMutation extends Relay.Mutation {
  getVariables() {
    return {};
  }

  getConfigs() {
    return [
      {
        type: 'FIELDS_CHANGE',
        fieldIDs: {
          zapperId: this.props.zapperId
        }
      }
    ];
  }

  getFatQuery() {
    return Relay.QL`
      fragment on ResendEmailVerificationPayload {
        zapperId
      }
    `;
  }

  getMutation() {
    return Relay.QL`mutation{resendEmailVerification}`;
  }
}



// WEBPACK FOOTER //
// ./js/mutations/ResendEmailVerificationMutation.js